<template>
  <div id="">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Kim ngạch từng nhân viên', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="buser" class="soft-control">
        <date-range title="Kim ngạch từng nhân viên" v-model="daterange" class="mx-1"></date-range>
        <div class="ml-2 mr-2">
          <hr />
          <b-row align-v="center">
            <b-col>
              <b-button block v-b-toggle.advSearch variant="primary">
                <i class="fa fa-binoculars"></i> Tìm kiếm nâng cao
              </b-button>
            </b-col>
            <!-- <b-col>
              <b-button @click="printDebt" block variant="success">
                <i class="fa fa-print"></i> In toàn bộ
              </b-button>
            </b-col> -->
            <b-col>
              <!-- <download-excel
                class="btn btn-primary btn-block"
                :data="debtTables"
                :fields="debtFields"
                :worksheet="worksheet"
                name="cong-no.xls"
              >
                <i class="fa fa-file-export"></i>
                Xuất file Excel
              </download-excel> -->

              <b-button variant="info" @click="exportExcel()">
                <i class="fa fa-file-export"></i>
                Xuất file excel
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-collapse id="advSearch" class="mt-2">
                <b-card>
                  <b-row>
                    <b-col md="4">
                      <base-input v-model="searcAdv.search" label="Từ khóa"> </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-select v-model="searcAdv.customer" label="Khách hàng" :ajaxData="getCustomer">
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="4">
                      <base-select label="Người phụ trách" v-model="searcAdv.user" :ajaxData="getUser">
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div class="d-flex">
                            <span class="avatar avatar-sm rounded-circle mr-2">
                              <img
                                v-holder="{
                                  img: '40x40',
                                  text: item.name
                                }"
                                @error="$imgHolder"
                                :alt="item.name"
                                :src="$mediaURI + item.avatar"
                              />
                            </span>
                            <div>
                              <strong>{{ item.name }}</strong>
                              <br />
                              <span>{{ item.phone }}</span>
                            </div>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="12">
                      <hr />
                      <b-button @click="fetchData" block variant="secondary ">
                        <i class="fa fa-search"></i> Tìm kiếm</b-button
                      >
                    </b-col>
                  </b-row>
                </b-card>
              </b-collapse>
            </b-col>
          </b-row>
        </div>
        <div class="mt-3">
          <time-line :data="timelines" v-model="timelineSelect" @timelineClick="timelineClick"></time-line>
        </div>
        <template>
          <b-card no-body class="mb-3 m-2" v-for="(debt, index) in debtTables" :key="index">
            <b-card-header header-tag="header" class="p-1 d-flex justify-content-between align-items-center">
              <div class="text-center d-block">
                <!-- <b>{{ timelineSelect.text }}</b> (<span>{{ timelineSelect.start }}</span
                >- <span>{{ timelineSelect.end }}</span
                >) -->
                <b>{{ debt.month }}</b>
              </div>
            </b-card-header>
            <b-card-body class="px-2">
              <soft-table
                @rowSelected="tbSetRowSelected"
                @rowClicked="tbRowClicked"
                class="table align-items-center table-flush"
                tbody-classes="list"
                :pending="false"
                :showAll="true"
                :dataTable="debt.users"
                :fields="fields"
                :autoheight="false"
                @contextMenuItemClick="tbHandleContextMenuItemClick"
                ref="soft-table"
              >
                <template v-slot:cell(avatar)="{ item }">
                  <span class="avatar avatar-sm rounded-circle">
                    <img
                      v-holder="{
                        img: '40x40',
                        text: item.username
                      }"
                      @error="$imgHolder"
                      :alt="item.name"
                      :src="$mediaURI + item.avatar"
                    />
                  </span>
                </template>
                <template v-slot:cell(currencys)="{ item }">
                  <ul class="text-right">
                    <li v-for="(cur, index) in item.currencys" :key="index">
                      <span>{{ $formatNumber(cur.summarry.totalAmout - cur.summarry.totalReturn) }}</span>
                      <b> {{ cur.currency }}</b>
                    </li>
                  </ul>
                </template>
                <template v-slot:cell(username)="row">
                  <b-button @click="row.toggleDetails" variant="link">
                    {{ row.value }}
                  </b-button>
                </template>
                <template v-slot:cell(name)="row">
                  <b-button @click="row.toggleDetails" variant="link">
                    {{ row.value }}
                  </b-button>
                </template>
                <template v-slot:row-details="row">
                  <div class="py-2" style="background:#fff">
                    <template v-for="(customer, index) in row.item.customers">
                      <b-card :key="index">
                        <div>
                          <b>Tên khách hàng: </b> {{ customer.name }}<br />
                          <b>Mã khách hàng: </b> {{ customer.code }}
                          <hr class="mt-1 mb-2" />
                        </div>
                        <div
                          :key="index"
                          style="margin-bottom:20px"
                          class="table-responsive base-table table-soft b-table-sticky-header"
                        >
                          <b-table
                            :filter-function="filterTable"
                            small
                            :fields="fieldsTurnover"
                            :items="customer.receiptBills"
                            responsive="sm"
                          >
                            <template v-slot:cell(dateCreated)="{ value }">
                              {{ $dateTimeUnix(value) }}
                            </template>
                            <template v-slot:cell(userCreated)="{ item }">
                              {{ item.userCreated.name }}
                            </template>
                            <template v-slot:cell(total)="{ item }">
                              {{ $formatNumber(item.total) }}
                              {{ item.currency }}
                            </template>
                            <template v-slot:cell(totalAmout)="{ item }">
                              {{ $formatNumber(item.totalAmout) }}
                              {{ item.currency }}
                            </template>
                            <template v-slot:cell(paid)="{ item }">
                              {{ $formatNumber(item.paid) }}
                              {{ item.currency }}
                            </template>
                            <template v-slot:cell(totalReturn)="row">
                              <b-button @click="row.toggleDetails" variant="link">
                                {{ $formatNumber(row.item.totalReturn) }}
                                {{ row.item.currency }}
                              </b-button>
                            </template>
                            <template v-slot:row-details="{ item }">
                              <div class="p-3">
                                <h4>Lịch sử trả hàng</h4>
                                <table
                                  class="table tablesorter b-table b-table-no-border-collapse b-table-selectable b-table-select-range b-table-selecting"
                                >
                                  <thead>
                                    <tr>
                                      <th>STT</th>
                                      <th>Ngày tạo</th>
                                      <th class="text-left">
                                        Người Tạo phiếu
                                      </th>
                                      <th class="text-right">Số lượng</th>
                                      <th class="text-right">Đơn giá</th>
                                      <th class="text-right">Thành tiền</th>
                                      <th class="text-right">Thành tiền sau thuế</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(row, index) in item.receiptBillReturn" :key="index">
                                      <td class="bg-info text-light col-fix ">
                                        {{ index + 1 }}
                                      </td>
                                      <td class="text-left">
                                        {{ $dateUnix(row.dateCreated) }}
                                      </td>
                                      <td class="text-left">
                                        {{ row.userCreated.name }}
                                      </td>
                                      <td class="text-right">
                                        {{ $formatNumber(row.quantity) }}
                                      </td>
                                      <td class="text-right">
                                        {{ $formatNumber(row.price) }}
                                        {{ item.currency }}
                                      </td>
                                      <td class="text-right">
                                        {{ $formatNumber(row.quantity * row.price) }}
                                        {{ item.currency }}
                                      </td>
                                      <td class="text-right">
                                        <!-- quantity: {{ row.quantity }} price : {{ row.price }} tax: {{ row.tax }} -->
                                        {{ $formatNumber(row.totalAmout ? row.totalAmout : row.quantity * row.price) }}
                                        {{ item.currency }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </template>
                            <template v-slot:cell(remain)="{ item }">
                              {{ $formatNumber(item.totalAmout - item.totalReturn - item.paid) }}
                              {{ item.currency }}
                            </template>
                            <!-- <template v-slot:custom-foot="">
                              <b-tr>
                                <b-th colspan="3">
                                  Tổng cộng
                                </b-th>
                                <b-th variant="info" class="text-right">
                                  {{ $formatNumber(cur.summarry.total) }}
                                  {{ cur.currency }}
                                </b-th>
                                <b-th variant="info" class="text-right">
                                  {{ $formatNumber(cur.summarry.totalAmout) }}
                                  {{ cur.currency }}
                                </b-th>
                                <b-th variant="info" class="text-right">
                                  {{ $formatNumber(cur.summarry.paid) }}
                                  {{ cur.currency }}
                                </b-th>
                                <b-th variant="info" class="text-right">
                                  {{ $formatNumber(cur.summarry.totalReturn) }}
                                  {{ cur.currency }}
                                </b-th>
                                <b-th variant="info" class="text-right">
                                  {{ $formatNumber(cur.summarry.total - cur.summarry.totalReturn - cur.summarry.paid) }}
                                  {{ cur.currency }}
                                </b-th>
                                <b-th></b-th>
                              </b-tr>
                            </template>
                            <b-tfoot>
                              <b-tr>
                                <b-td colspan="4">Tổng cộng</b-td>
                                <b-td class="text-right">
                                  {{ $formatNumber(cur.summarry.total) }}
                                  {{ cur.currency }}
                                </b-td>
                                <b-td class="text-right">
                                  {{ $formatNumber(cur.summarry.totalAmout) }}
                                  {{ cur.currency }}
                                </b-td>
                                <b-td class="text-right">
                                  {{ $formatNumber(cur.summarry.paid) }}
                                  {{ cur.currency }}
                                </b-td>
                                <b-td class="text-right">
                                  {{ $formatNumber(cur.summarry.total - cur.summarry.paid) }}
                                  {{ cur.currency }}
                                </b-td>
                              </b-tr>
                            </b-tfoot> -->
                          </b-table>
                        </div>
                      </b-card>
                    </template>
                  </div>
                </template>
                <!-- <template v-slot:custom-foot=""></template> -->
              </soft-table>
            </b-card-body>
            <b-card v-if="debt.users.length == 0" class="m-2">
              <h4>Chưa có đơn hàng nào trong khoản thời gian này</h4>
            </b-card>
          </b-card>
        </template>
      </block>
    </div>
    <preview ref="preview"></preview>
  </div>
</template>
<script>
import { receiptService, userService, customerService } from '@/_services';
import { addDateTime, formatJSDate, formatDateUnix } from '@/utils/date';
import JsonExcel from 'vue-json-excel';

import { mapState } from 'vuex';
import XLSX from 'xlsx';
import Preview from './__Preview';
import { avatar } from '@/_services/modules/upload.service';
export default {
  name: 'turnover-user-manage',
  components: {
    Preview,
    downloadExcel: JsonExcel
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0,
        from: addDateTime(-6),
        to: new Date()
      },
      searcAdv: {
        search: '',
        customer: '',
        user: ''
      },
      daterange: {},
      debtTables: [],
      worksheet: 'Công nợ',
      debtFields: {
        STT: 'stt',
        'Tên nhân viên': 'name',
        Email: 'email',
        Phone: 'phone',
        'Kim ngạch': {
          callback: value => {
            let result = '';
            value.currencys.forEach(cur => {
              result += `${cur.summarry.totalAmout - cur.summarry.totalReturn} ${cur.currency} `;
            });
            return result;
            //return `${value.total - value.paid - value.totalReturn}`;
          }
        },
        'Loại tiền': 'currency'
      },
      lastIndexCustomerSelected: 0,
      debts: [],
      timelines: [{ text: '06/2020' }, { text: '07/2020' }, { text: '08/2020' }, { text: '09/2020' }],
      timelineSelect: {
        text: ''
      },
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'col-fix checkbox'
        },
        {
          key: 'avatar',
          label: 'Hình đại diện',
          sortable: true,
          class: 'col-fix text-center'
        },
        {
          key: 'name',
          label: 'Họ tên nhân viên',
          sortable: true
        },
        {
          key: 'username',
          label: 'Tên đăng nhập',
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'phone',
          label: 'Số điện thoại',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'currencys',
          label: 'Kim ngạch',
          sortable: true
        }
      ],
      fieldsTurnover: [
        {
          variant: 'primary',
          key: 'id',
          label: 'STT',
          class: 'col-fix checkbox'
        },
        {
          key: 'code',
          label: 'Mã phiếu xuất',
          sortable: true,
          class: 'col-fix'
        },
        {
          key: 'userCreated',
          label: 'Người tạo phiếu',
          sortable: true,
          class: ''
        },
        {
          key: 'total',
          label: 'Tổng tiền',
          sortable: true,
          class: 'col-fix text-right'
        },
        {
          key: 'totalAmout',
          label: 'Tổng tiền sau thuế',
          sortable: true,
          class: 'col-fix text-right'
        },
        {
          key: 'paid',
          label: 'Đã thanh toán',
          sortable: true,
          class: 'col-fix text-right'
        },
        {
          key: 'totalReturn',
          label: 'Tiền hàng trả lại',
          sortable: true,
          class: 'col-fix text-right'
        },
        {
          key: 'remain',
          label: 'Còn lại',
          sortable: true,
          class: 'col-fix text-right'
        },
        {
          key: 'dateCreated',
          label: 'Ngày tạo',
          sortable: true,
          class: 'col-fix'
        }
      ],
      allCurrency: []
    };
  },
  computed: {
    ...mapState('user', ['info'])
  },
  mounted() {
    setTimeout(() => {
      this.daterange = {
        from: addDateTime(-6),
        to: new Date()
      };
    }, 100);
  },
  methods: {
    fetchData() {
      var self = this;
      this.listQuery.from = this.timelineSelect.start;
      this.listQuery.to = this.timelineSelect.end;
      if (this.searcAdv.user) {
        this.listQuery.userId = this.searcAdv.user.id;
      } else {
        this.listQuery.userId = '';
      }
      if (this.searcAdv.customer) {
        this.listQuery.customerId = this.searcAdv.customer.id;
      } else {
        this.listQuery.customerId = '';
      }
      this.listQuery.search = this.searcAdv.search;

      this.worksheet = `${this.$date(this.daterange.from, 'DD_MM_YYYY')} - ${this.$date(
        this.daterange.to,
        'DD_MM_YYYY'
      )}`;
      self.debtTables = [];
      receiptService.turnoverUser(this.listQuery).then(res => {
        let receipts = res.data.data;
        self.debtTables = [];

        let deptForMonths = {};
        receipts.forEach(element => {
          let customers = element.customer;
          customers.forEach(customer => {
            let receiptBills = customer.receiptBill;
            receiptBills.forEach(receiptBill => {
              let monthQuery = formatDateUnix(receiptBill.dateCreated, 'MM_YYYY');
              if (!deptForMonths[monthQuery]) {
                let receiptBilltmp = Object.assign({}, receiptBill);
                receiptBilltmp.receiptBillReturn = [];
                receiptBilltmp.ReceiptBillDetail = [];

                deptForMonths[monthQuery] = {
                  users: [
                    {
                      avatar: element.avatar,
                      name: element.name,
                      username: element.username,
                      email: element.email,
                      id: element.id,
                      phone: element.phone,
                      customers: [
                        {
                          name: customer.name,
                          code: customer.code,
                          short_name: customer.short_name,
                          id: customer.id,
                          tax: customer.tax,
                          mobile: customer.mobile,
                          address: customer.address,
                          avatar: customer.avatar,
                          status: customer.status,
                          receiptBills: [receiptBill]
                        }
                      ],
                      receiptBills: [receiptBilltmp]
                    }
                  ],
                  month: monthQuery
                };
              } else {
                let deptMonth = deptForMonths[monthQuery];
                let users = deptMonth.users;
                let indexUser = users.findIndex(user => user.id == element.id);
                if (indexUser == -1) {
                  let receiptBilltmp = Object.assign({}, receiptBill);
                  receiptBilltmp.receiptBillReturn = [];
                  receiptBilltmp.ReceiptBillDetail = [];
                  users.push({
                    avatar: element.avatar,
                    name: element.name,
                    id: element.id,
                    username: element.username,
                    email: element.email,
                    phone: element.phone,
                    customers: [
                      {
                        name: customer.name,
                        code: customer.code,
                        short_name: customer.short_name,
                        id: customer.id,
                        tax: customer.tax,
                        mobile: customer.mobile,
                        address: customer.address,
                        avatar: customer.avatar,
                        status: customer.status,
                        receiptBills: [receiptBill]
                      }
                    ],
                    receiptBills: [receiptBilltmp]
                  });
                } else {
                  customers = users[indexUser].customers;
                  let indexCustomer = customers.findIndex(cus => cus.id == customer.id);
                  if (indexCustomer == -1) {
                    customers.push({
                      name: customer.name,
                      code: customer.code,
                      short_name: customer.short_name,
                      id: customer.id,
                      tax: customer.tax,
                      mobile: customer.mobile,
                      address: customer.address,
                      avatar: customer.avatar,
                      status: customer.status,
                      receiptBills: [receiptBill]
                    });
                  } else {
                    customers[indexCustomer].receiptBills.push(receiptBill);
                  }
                  let receiptBilltmp = Object.assign({}, receiptBill);
                  receiptBilltmp.receiptBillReturn = [];
                  receiptBilltmp.ReceiptBillDetail = [];
                  users[indexUser].receiptBills.push(receiptBilltmp);
                }
              }
            });
          });
        });

        //duyệt và lấy item của Object deptForMonths
        let keys = Object.keys(deptForMonths);
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i];
          let deptMonth = deptForMonths[key];
          let users = deptMonth.users;
          users.forEach(user => {
            // let receiptBills = user.receiptBills;
            let customers = user.customers;
            let currencys = [];

            customers.forEach(customer => {
              let receiptBills = customer.receiptBills;
              receiptBills.forEach(receiptBill => {
                let currency = this.checkItemInArray(currencys, receiptBill.currency, 'currency');
                let receiptBillReturn = receiptBill.receiptBillReturn;
                let totalReturn = 0;
                if (receiptBillReturn.length > 0) {
                  receiptBillReturn.forEach(billReturn => {
                    totalReturn += billReturn.price * billReturn.quantity;
                  });
                }
                receiptBill.totalReturn = totalReturn;
                if (!currency || currency == false) {
                  let currencySummarry = {
                    currency: receiptBill.currency,
                    summarry: {
                      total: receiptBill.total,
                      totalAmout:
                        receiptBill.totalAmout > receiptBill.total ? receiptBill.totalAmout : receiptBill.total,
                      paid: receiptBill.paid,
                      totalReturn: receiptBill.totalReturn
                    }
                  };
                  currencys.push(currencySummarry);
                } else {
                  currency.summarry.total += receiptBill.total;
                  currency.summarry.totalAmout +=
                    receiptBill.totalAmout > receiptBill.total ? receiptBill.totalAmout : receiptBill.total;
                  currency.summarry.paid += receiptBill.paid;
                  currency.summarry.totalReturn += receiptBill.totalReturn;
                }
              });
            });

            user.currencys = currencys;
          });
        }
        self.debtTables = Object.values(deptForMonths);
        // this.debts = Object.values(debt);
        // this.debts.forEach(element => {
        //   element.customers = Object.values(element.customers);
        // });
        console.log(self.debtTables);
      });
    },
    fetchDataOld() {
      var self = this;
      this.listQuery.from = this.timelineSelect.start;
      this.listQuery.to = this.timelineSelect.end;
      if (this.searcAdv.user) {
        this.listQuery.userId = this.searcAdv.user.id;
      } else {
        this.listQuery.userId = '';
      }
      if (this.searcAdv.customer) {
        this.listQuery.customerId = this.searcAdv.customer.id;
      } else {
        this.listQuery.customerId = '';
      }
      this.listQuery.search = this.searcAdv.search;

      this.worksheet = `${this.$date(this.daterange.from, 'DD_MM_YYYY')} - ${this.$date(
        this.daterange.to,
        'DD_MM_YYYY'
      )}`;
      this.allCurrency = [];
      receiptService.turnoverUser(this.listQuery).then(res => {
        let receipts = res.data.data;
        self.debtTables = [];
        // element === user
        let stt = 1;
        receipts.forEach(element => {
          let customers = element.customer;
          let summarry = [];
          customers.forEach(customer => {
            let receiptBills = customer.receiptBill;
            customer.currencys = [];
            receiptBills.forEach(receiptBill => {
              let currency = this.checkItemInArray(customer.currencys, receiptBill.currency, 'currency');

              // debugger;
              let receiptBillReturn = receiptBill.receiptBillReturn;
              let totalReturn = 0;
              if (receiptBillReturn.length > 0) {
                receiptBillReturn.forEach(billReturn => {
                  totalReturn += billReturn.price * billReturn.quantity;
                });
              }
              receiptBill.totalReturn = totalReturn;

              if (!currency || currency == false) {
                let currencySummarry = {
                  currency: receiptBill.currency,
                  summarry: {
                    total: receiptBill.total,
                    totalAmout: receiptBill.totalAmout > receiptBill.total ? receiptBill.totalAmout : receiptBill.total,
                    paid: receiptBill.paid,
                    totalReturn: receiptBill.totalReturn
                  }
                };
                customer.currencys.push(currencySummarry);
              } else {
                currency.summarry.total += receiptBill.total;
                currency.summarry.totalAmout +=
                  receiptBill.totalAmout > receiptBill.total ? receiptBill.totalAmout : receiptBill.total;
                currency.summarry.paid += receiptBill.paid;
                currency.summarry.totalReturn += receiptBill.totalReturn;
              }
            });
            customer.currencys.forEach(cur => {
              if (!summarry[cur.currency]) {
                summarry[cur.currency] = {
                  currency: cur.currency,
                  summarry: cur.summarry
                };
              } else {
                let oldSumarry = summarry[cur.currency];

                let paid = oldSumarry.summarry.paid + cur.summarry.paid;
                let total = oldSumarry.summarry.total + cur.summarry.total;
                let totalAmout = oldSumarry.summarry.totalAmout + cur.summarry.totalAmout;
                let totalReturn = oldSumarry.summarry.totalReturn + cur.summarry.totalReturn;

                summarry[cur.currency] = {
                  currency: cur.currency,
                  summarry: {
                    paid,
                    total,
                    totalAmout,
                    totalReturn
                  }
                };
              }
            });
          });
          element.summarrys = Object.values(summarry);
          element.stt = stt;
          stt++;
          this.debtTables.push(element);
        });
        // this.debts = Object.values(debt);
        // this.debts.forEach(element => {
        //   element.customers = Object.values(element.customers);
        // });
        console.log(this.debtTables);
      });
    },
    filterTable(row, filter) {
      return row.currency == filter.currency;
      // if (this.filter) {
      //   if (row[this.filter.key] == this.filter.value) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // } else {
      //   if (row.active || this.showAll) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // }
    },
    exportExcel() {
      let fileName = 'KIMNGACH_' + this.listQuery.from + '_' + this.listQuery.to;
      var new_workbook = XLSX.utils.book_new();

      let arrData = [];
      for (let i = 0; i < this.debtTables.length; i++) {
        const debtItem = this.debtTables[i];
        // arrData.push([
        //   "Tháng",
        //   debtItem.month
        // ]);
        let users = debtItem.users;
        users.forEach(user => {
          let currencys = user.currencys;
          for (let j = 0; j < currencys.length; j++) {
            const currency = currencys[j];

            arrData.push([
              debtItem.month,
              user.name,
              user.email,
              user.phone,
              'Kim ngạch',
              currency.summarry.totalAmout - currency.summarry.totalReturn,
              currency.currency
            ]);
          }
        });
      }
      var worksheet = XLSX.utils.aoa_to_sheet(arrData);
      XLSX.utils.book_append_sheet(new_workbook, worksheet, 'sheet1');
      XLSX.writeFile(new_workbook, fileName + '.xlsx');
    },
    timelineClick() {
      this.debtTables = [];
      this.fetchData();
    },
    checkItemInArray(arr, value, key) {
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        if (element[key] == value) {
          return element;
        }
      }
      return false;
    },
    getUser(keyword, cb) {
      userService.adminGetAllUser({ search: keyword }).then(res => {
        let data = res.data.data;
        data.push(this.info);
        data.push({
          id: -1,
          name: 'Tất cả nhân viên'
        });
        cb(data);
      });
    },
    getCustomer(keyword, cb) {
      customerService.findAll({ search: keyword }).then(res => {
        let data = res.data.data;
        data.push({
          id: -1,
          name: 'Tất cả khách hàng'
        });
        cb(data);
      });
    },
    printDebt() {
      this.$refs.preview.visible = true;
      let debt = {
        from: this.daterange.from,
        to: this.daterange.to,
        data: this.debts
      };
      this.$refs.preview.setData(debt);
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log('context menu', a);
    },
    handleUpdate() {},
    handleCreate() {},
    handleCopy() {},
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.customerSelecteds = items;
      this.countChecked = items.length;
    },
    dateRange(startDate, endDate) {
      var start = startDate.split('-');
      var end = endDate.split('-');
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      var dates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
          var month = j + 1;
          var displayMonth = month < 10 ? '0' + month : month;
          dates.push([i, displayMonth, '01'].join('-'));
        }
      }
      return dates;
    }
  },
  watch: {
    daterange: function() {
      this.timelines = this.$dateRange(this.daterange.from, this.daterange.to);

      this.timelines.unshift({
        text: 'Tất cả',
        start: formatJSDate(this.daterange.from, 'YYYY-MM-DD'),
        end: formatJSDate(this.daterange.to, 'YYYY-MM-DD')
      });

      if (this.timelines.length > 0) {
        this.timelineSelect = this.timelines[this.timelines.length - 1];
      }
      this.fetchData();
    }
  }
};
</script>
<style lang="scss"></style>
